/**
 * The fraud decision response types recognized by DOMS.
 */
export enum FraudDecisionType {
  'Accepted' = 'ACCEPTED',
  'Approved' = 'APPROVED',
  'NotSent' = 'NOT_SENT',
  'NotReviewed' = 'NOT_REVIEWED',
  'Failed' = 'FAILED',
  'Error' = 'ERROR',
  'Declined' = 'DECLINED'
}
